module.exports = __webpack_public_path__ + "static/media/wenceslasLeChevalier.9363f368.png";